// 화면에서 사용하는 데이터부 선언
export default {
	//tables : [],

	// 선택한 테이블 Row
	//selectedRows: [],
	tableInfoList: [],

	useYnOptions: [],

	// 사용자 공통팝업 파라미터 정보
	searchUserPopParams: {
		userName: '',
		userId: ''
	},

	// 검색조건 파라미터 정보
	searchParams: {
		tableName: '',
		tbComment: '',
		colName: '',
		colComment: '',
		useYn: 'Y'
	},

	refTableInfoTable: null,

	// 페이징 처리를 위한 정보 데이터부
	pagingInfo: {
		currentPage: 1,
		pageUnit: 30,
		totalSize: 0
	},

	groups: {
		currentPage: 1,
		pageUnit: 30,
		totalSize: 0
	},

	schema: null
};
